"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.cached = exports.minutes = exports.seconds = void 0;
var cache_1 = require("../../../cache");
var object_hash_1 = __importDefault(require("object-hash"));
function seconds(num, max) {
    if (max === void 0) { max = 100; }
    return {
        max: max,
        maxAge: num * 1000
    };
}
exports.seconds = seconds;
function minutes(num, max) {
    if (max === void 0) { max = 100; }
    return seconds(num * 60, max);
}
exports.minutes = minutes;
var cacheKeyAddress = function (address) { return address; };
var cacheKeyEmpty = function () { return ""; };
var cacheKeyAssocTokenAccAddress = function (owner, mint) {
    return "".concat(owner, ":").concat(mint);
};
var cacheKeyTransactions = function (signatures) {
    return (0, object_hash_1["default"])(__spreadArray([], __read(signatures), false).sort());
};
var cacheKeyByArgs = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (0, object_hash_1["default"])(args);
};
function cached(api) {
    return {
        findAssocTokenAccAddress: (0, cache_1.makeLRUCache)(api.findAssocTokenAccAddress, cacheKeyAssocTokenAccAddress, minutes(1000)),
        getAccountInfo: (0, cache_1.makeLRUCache)(api.getAccountInfo, cacheKeyAddress, seconds(30)),
        getAssocTokenAccMinNativeBalance: (0, cache_1.makeLRUCache)(api.getAssocTokenAccMinNativeBalance, cacheKeyEmpty, minutes(5)),
        getBalance: (0, cache_1.makeLRUCache)(api.getBalance, cacheKeyAddress, seconds(30)),
        getBalanceAndContext: (0, cache_1.makeLRUCache)(api.getBalanceAndContext, cacheKeyAddress, seconds(30)),
        getParsedConfirmedTransactions: (0, cache_1.makeLRUCache)(api.getParsedConfirmedTransactions, cacheKeyTransactions, seconds(30)),
        getParsedTokenAccountsByOwner: (0, cache_1.makeLRUCache)(api.getParsedTokenAccountsByOwner, cacheKeyAddress, minutes(1)),
        getRecentBlockhash: (0, cache_1.makeLRUCache)(api.getRecentBlockhash, cacheKeyEmpty, seconds(5)),
        getTxFeeCalculator: (0, cache_1.makeLRUCache)(api.getTxFeeCalculator, cacheKeyEmpty, minutes(5)),
        getSignaturesForAddress: (0, cache_1.makeLRUCache)(api.getSignaturesForAddress, cacheKeyByArgs, seconds(30)),
        // do not cache
        sendRawTransaction: api.sendRawTransaction,
        config: api.config
    };
}
exports.cached = cached;
//# sourceMappingURL=cached.js.map